/**
 * Convert base64 string to Blob
 *
 * @param {string} base64 - The base64 string
 * @param {string} contentType - The content type of the file
 *
 * @returns {Blob}
 */
export default function convertBase64ToBlob(base64, contentType) {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);

  return new Blob([byteArray], { type: contentType });
}
